import { Component, OnInit } from "@angular/core";
import { WindowsNotificationService } from "../../../services/windows-notification.service";
import { ReportsService } from "../../../services/reports.service";
import { UserService } from "../../../domain/user-service";
import { throttleTime } from "rxjs/operators";

@Component({
  selector: "evrideo-empty-contracts-report",
  templateUrl: "./empty-contracts-report.component.html",
  styleUrls: ["./empty-contracts-report.component.scss"],
})
export class EmptyContractsReportComponent {
  showPreloader: boolean;
  rows = [];
  selected = [];
  columns = [
    { name: "ID", prop: "customId" },
    { name: "Media Title", prop: "mediaTitle" },
  ];

  constructor(
    private windowsNotificationService: WindowsNotificationService,
    private reportsService: ReportsService,
    private userService: UserService,
  ) {
    windowsNotificationService.ACTIONS.showEmptyContractsReport.subscribe(
      () => {
        this.loadReport();

        console.log("refreshing the report");

        const globalState = this.reportsService.reportsGlobalState
          .pipe(throttleTime(3000))
          .subscribe(() => {
            this.loadReport();
          });

        // clean up listeners
        windowsNotificationService.ACTIONS.closeEmptyContractsReport
          .subscribe(() => {
            globalState.unsubscribe();
          })
          .unsubscribe();
      },
    );
  }

  clickOnCloseBtnHandler() {
    this.windowsNotificationService.ACTIONS.closeEmptyContractsReport.next(
      true,
    );
  }

  private loadReport() {
    this.showPreloader = true;

    this.userService.getCurrentChannel().then(({ id }) => {
      this.reportsService.getEmptyContractsReport(id).then((report) => {
        this.rows = this.mapDtos(report);

        this.showPreloader = false;
      });
    });
  }

  private mapDtos(report: Array<any>) {
    return report.map((entry) => {
      const dto: any = { ...entry };

      return dto;
    });
  }
}
